import React from "react";
import ZillowNavBar from "../assets/zillow-header.png";
import SearchIcon from "../assets/search-icon.png";
import "../styles/ZillowHeader.css";

const ZillowHeader = () => (
  <div className="navbar">
    <img src={ZillowNavBar} alt="Zillow Header" width="100%" height={70} />
    <div className="header">
      <ul>
        <li className="searchbar">
          <input type="text" name="location" defaultValue="New York, NY" />
          <img src={SearchIcon} alt="Search Icon" width={15} height={15} />
        </li>
        <li className="neighborhood-menu">Neighborhood Research</li>
      </ul>
      <ul>
        <li className="for-sale">
          <div className="sale-circle" />
          For Sale
        </li>
        <li>Price</li>
        <li>Bed & Baths</li>
        <li>Home type</li>
        <li>More</li>
        <li className="save-search">Save search</li>
      </ul>
    </div>
  </div>
);

export default ZillowHeader;
